import { render, staticRenderFns } from "./SidebarCpt.vue?vue&type=template&id=64669aea&scoped=true&"
import script from "./SidebarCpt.vue?vue&type=script&lang=ts&"
export * from "./SidebarCpt.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarCpt.vue?vue&type=style&index=0&id=64669aea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64669aea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VIcon,VImg,VList,VListItem,VListItemContent,VListItemTitle,VNavigationDrawer,VTooltip})
